<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari berdasarkan nama"
        search-action="user/getUserList"
        :payload="defaultFilter"
      >
        <template #action>
          <b-button
            v-if="canAccess('manage', 'Affiliate')"
            variant="primary"
            @click="openModalCreate"
          >
            Daftarkan Affiliator
          </b-button>
        </template>
      </table-header>
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="users.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >

        <!-- Column: Name -->
        <template #cell(name)="data">
          <div class="d-flex align-items-center">
            <b-avatar
              variant="primary"
              :text="initialText(data.item.name)"
              class="align-baseline"
              :src="linkStaging(data.item.photo)"
            />
            <span class="ml-1"> {{ data.item.name }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canAccess('manage', 'Affiliate')"
          #cell(actions)="data"
        >
          <div class="text-nowrap">
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="users.meta"
          :payload="defaultFilter"
          action="user/getUserList"
        />
      </div>
    </b-card>

    <b-modal
      v-if="canAccess('manage', 'Affiliate')"
      id="modal-delete"
      title="Apakah anda yakin"
      @hidden="deletedData = ''"
    >
      Ingin Menghapus Affiliator ini?
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isDeleting"
          @click="cancel()"
        >
          Batalkan
        </b-button>
        <b-button
          variant="danger"
          :disabled="isDeleting"
          @click.prevent="handleDelete"
        >
          <b-spinner
            v-if="isDeleting"
            small
            label="Spinning"
          />
          {{ isDeleting ? 'Menghapus' : 'Ya, Hapus' }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-if="canAccess('manage', 'Affiliate')"
      v-model="modalCreate"
      title="Tambah Affiliator"
      hide-footer
      no-close-on-backdrop
    >
      <AffiliatorForm @onSubmit="onFinishCreate" />
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BSkeletonTable,
  BCard,
  BButton,
  BTable,
  BSpinner,
  BAvatar,
} from 'bootstrap-vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'
import AffiliatorForm from '@/layouts/components/form/AffiliatorForm.vue'

export default {
  components: {
    BSkeletonTable,
    BCard,
    BButton,
    BTable,
    BSpinner,
    BAvatar,
    Pagination,
    TableHeader,
    TableAction,
    AffiliatorForm,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      deletedData: '',
      isDeleting: false,
      modalCreate: false,
      defaultFilter: {
        type: 'affiliator',
      },
    }
  },
  computed: {
    ...mapState('user', ['users', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: null,
          action: data => { window.open(`https://wa.me/${data.phone}`) },
          icon: 'MessageSquareIcon',
          title: 'Buka di Whatsapp',
        },
        {
          access: null,
          to: null,
          action: data => { this.deleteConfirmation(data.id) },
          icon: 'TrashIcon',
          title: 'Hapus',
        },
      ]
    },
  },
  async created() {
    await this.getUserList({ ...this.query, ...this.defaultFilter })
  },
  methods: {
    ...mapActions('user', ['getUserList']),
    ...mapActions('affiliate', ['deleteAffiliator']),
    deleteConfirmation(value) {
      this.$bvModal.show('modal-delete')
      this.deletedData = value
    },
    async handleDelete() {
      this.isDeleting = true
      await this.deleteAffiliator({ userId: this.deletedData })
      this.isDeleting = false
      this.$bvModal.hide('modal-delete')
      this.getUserList({ ...this.query, ...this.defaultFilter })
    },
    openModalCreate() {
      this.modalCreate = true
    },
    onFinishCreate() {
      this.modalCreate = false
      this.getUserList({ ...this.query, ...this.defaultFilter })
    },
  },
}
</script>
